<ngx-spinner
  bdColor="rgba(250, 250, 250, 0.9)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  template="<div class='loader-box show' ><div id='loader'><div class='circle-loader'><div class='circle circle-1'></div><div class='circle circle-2'></div><div class='circle circle-3'></div><div class='circle circle-4'></div></div></div>
  <style>
    .loader-box {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      opacity: 0; /* Başlangıçta gizle */
      pointer-events: none; /* Tıklanmaz hale getir */
      transition: opacity 0.5s ease, visibility 0.5s ease; /* Geçiş ekleyelim */
    }

    .loader-box.show {
      opacity: 1; /* Yalnızca 'show' sınıfı eklenince görünür */
      pointer-events: auto; /* Tıklanabilir hale getir */
    }
    .loader-box.ng-leave {
      opacity: 0;
      pointer-events: none;
    }

    #loader {
      width: 100%;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .circle-loader {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .circle {
      position: absolute;
      border: 3.5px solid transparent;
      border-radius: 50%;
      animation: rotate 3s infinite ease-in-out;
    }

    .circle-1 {
      width: 250px;
      height: 250px;
      border-top-color: #0c9;
      border-right-color: #0c9;
      animation-delay: -0.15s;
    }

    .circle-2 {
      width: 200px;
      height: 200px;
      border-top-color: #0d1a36;
      border-right-color: #0d1a36;
      animation-delay: -0.3s;
    }

    .circle-3 {
      width: 150px;
      height: 150px;
      border-top-color: #0c9;
      border-right-color: #0c9;
      animation-delay: -0.45s;
    }

    .circle-4 {
      width: 100px;
      height: 100px;
      border-top-color: #0d1a36;
      border-right-color: #0d1a36;
      animation-delay: -0.6s;
    }

    @keyframes rotate {
      50% {
        transform: rotate(360deg);
      }
    }

    .timer-text {
      position: absolute;
      font-size: 48px;
      color: black;
    }
  </style>"
>
  <p style="font-size: 20px; color: white"></p>
</ngx-spinner>
<router-outlet></router-outlet>


  <style>
    .loader-box {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      opacity: 0; /* Başlangıçta gizle */
      pointer-events: none; /* Tıklanmaz hale getir */
      transition: opacity 0.5s ease, visibility 0.5s ease; /* Geçiş ekleyelim */
    }

    .loader-box.show {
      opacity: 1; /* Yalnızca 'show' sınıfı eklenince görünür */
      pointer-events: auto; /* Tıklanabilir hale getir */
    }
    .loader-box.ng-leave {
      opacity: 0;
      pointer-events: none;
    }

    #loader {
      width: 100%;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .circle-loader {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .circle {
      position: absolute;
      border: 3.5px solid transparent;
      border-radius: 50%;
      animation: rotate 3s infinite ease-in-out;
    }

    .circle-1 {
      width: 250px;
      height: 250px;
      border-top-color: #0c9;
      border-right-color: #0c9;
      animation-delay: -0.15s;
    }

    .circle-2 {
      width: 200px;
      height: 200px;
      border-top-color: #0d1a36;
      border-right-color: #0d1a36;
      animation-delay: -0.3s;
    }

    .circle-3 {
      width: 150px;
      height: 150px;
      border-top-color: #0c9;
      border-right-color: #0c9;
      animation-delay: -0.45s;
    }

    .circle-4 {
      width: 100px;
      height: 100px;
      border-top-color: #0d1a36;
      border-right-color: #0d1a36;
      animation-delay: -0.6s;
    }

    @keyframes rotate {
      50% {
        transform: rotate(360deg);
      }
    }

    .timer-text {
      position: absolute;
      font-size: 48px;
      color: black;
    }
  </style>

